import { brand } from "../../theme";
import { Box, Typography, Container, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const contactOptions = [
  {
    Icon: ForumOutlinedIcon,
    title: "Request a Consultation",
    detail: "Free 15 minute phone consultation",
    component: Link,
    props: { to: "/request-consultation" },
  },
  {
    Icon: PhoneOutlinedIcon,
    title: "Call or Text",
    detail: "407-797-5469",
    component: "a",
    props: { href: "tel:4077975469" },
  },
  {
    Icon: EmailOutlinedIcon,
    title: "Email",
    detail: "rothenbergcounseling@gmail.com",
    component: "a",
    props: { href: "mailto:rothenbergcounseling@gmail.com" },
  },
];

const ContactSection = () => {
  return (
    <Container maxWidth="lg" sx={{ my: { xs: 5, md: 10 } }}>
      <Box
        sx={{
          backgroundColor: "secondary.light",
          border: brand.borderSoft,
          borderRadius: { xs: 3, md: 4 },
          p: { xs: 3, md: 6 },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "1.75rem", sm: "2rem", md: "2.25rem" },
            fontWeight: 700,
            textAlign: "center",
            mb: 2,
            color: "headline.main",
          }}
        >
          Get in Touch
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", md: "1.125rem" },
            textAlign: "center",
            color: "#666",
            mb: { xs: 4, md: 5 },
            mx: "auto",
            maxWidth: "650px",
          }}
        >
          Reach out however feels most comfortable. Text, call, email, or the
          form, it all goes straight to Dr. Anne, and she answers every one
          personally. Everything you share is confidential, starting with your
          very first message.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
            justifyContent: "center",
            gap: { xs: 2, md: 3 },
          }}
        >
          {contactOptions.map((option) => (
            <Button
              key={option.title}
              component={option.component}
              {...option.props}
              variant="warmCard"
              sx={{
                flex: { md: 1 },
                maxWidth: { md: "320px" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                p: { xs: 3, md: 4 },
              }}
            >
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "10px",
                  backgroundColor: "secondary.light",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 0.5,
                }}
              >
                <option.Icon sx={{ fontSize: 26, color: "primary.main" }} />
              </Box>
              <Typography
                sx={{
                  color: "headline.main",
                  fontWeight: 700,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                }}
              >
                {option.title}
              </Typography>
              <Typography
                sx={{
                  color: "#666",
                  fontSize: { xs: "0.875rem", md: "0.95rem" },
                  wordBreak: "break-word",
                }}
              >
                {option.detail}
              </Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default ContactSection;
